// Worker do ELK empacotado pelo webpack. Fica num .js porque o tsconfig do
// projeto (module padrão) não aceita `import.meta`; o Babel do CRA aceita.
export const createElkWorker = () =>
  new Worker(new URL("elkjs/lib/elk-worker.min.js", import.meta.url));
